var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3966_47453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.150391C5.87827 0.150391 3.84344 0.993245 2.34315 2.49354C0.842855 3.99383 0 6.02866 0 8.15039C0 10.2721 0.842855 12.307 2.34315 13.8072C3.84344 15.3075 5.87827 16.1504 8 16.1504C10.1217 16.1504 12.1566 15.3075 13.6569 13.8072C15.1571 12.307 16 10.2721 16 8.15039C16 6.02866 15.1571 3.99383 13.6569 2.49354C12.1566 0.993245 10.1217 0.150391 8 0.150391V0.150391ZM11.5 7.65039C11.6326 7.65039 11.7598 7.70307 11.8536 7.79684C11.9473 7.89061 12 8.01778 12 8.15039C12 8.283 11.9473 8.41018 11.8536 8.50394C11.7598 8.59771 11.6326 8.65039 11.5 8.65039H5.707L7.854 10.7964C7.90049 10.8429 7.93736 10.8981 7.96252 10.9588C7.98768 11.0195 8.00063 11.0846 8.00063 11.1504C8.00063 11.2161 7.98768 11.2812 7.96252 11.342C7.93736 11.4027 7.90049 11.4579 7.854 11.5044C7.80751 11.5509 7.75232 11.5878 7.69158 11.6129C7.63084 11.6381 7.56574 11.651 7.5 11.651C7.43426 11.651 7.36916 11.6381 7.30842 11.6129C7.24768 11.5878 7.19249 11.5509 7.146 11.5044L4.146 8.50439C4.09944 8.45794 4.06249 8.40277 4.03729 8.34202C4.01208 8.28128 3.99911 8.21616 3.99911 8.15039C3.99911 8.08462 4.01208 8.0195 4.03729 7.95876C4.06249 7.89801 4.09944 7.84284 4.146 7.79639L7.146 4.79639C7.23989 4.7025 7.36722 4.64976 7.5 4.64976C7.63278 4.64976 7.76011 4.7025 7.854 4.79639C7.94789 4.89028 8.00063 5.01761 8.00063 5.15039C8.00063 5.28317 7.94789 5.4105 7.854 5.50439L5.707 7.65039H11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3966_47453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/iconLeft.d1dcef4469f7e316c6d2503854bf5ae4.svg";
export { ForwardRef as ReactComponent };